// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-play-my-clips__container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px 24px;
    padding: 29px 71px;
}

.baloa-play-my-clips__clip-container {
    background: var(--white-color);
    padding: 12px;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    cursor: pointer;
}

.baloa-play-my-clips__clip-container img {
    border-radius: 8px;
    height: 137px;
    width: 100%;
    object-fit: cover;
}

.baloa-play-my-clips__clip-container .baloa-names {
    color: var(--primary-very-dark-color);
    margin-top: 12px;
}

.baloa-play-my-clips__match-data {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin-top: 12px;
}


.baloa-play-my-clips__match-data .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 

    .baloa-play-my-clips__container {
        padding: 10px;
        display: flex;
        flex-direction: column;
    }

    .baloa-play-my-clips__clip-container .baloa-names {
        margin-top: 0;
    }

    .baloa-play-my-clips__mobile-data {
        display: flex;
        gap: 12px;
        margin-top: 12px;
    }

    .baloa-play-my-clips__mobile-data img {
        height: 79px;
        width: 129px;
        border-radius: 6px;
    }

    .baloa-play-my-clips__match-data {
        margin-top: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-my-clips-component/BaloaPlayMyClipsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;;AAGA;IACI,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,aAAa;QACb,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".baloa-play-my-clips__container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px 24px;\n    padding: 29px 71px;\n}\n\n.baloa-play-my-clips__clip-container {\n    background: var(--white-color);\n    padding: 12px;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    cursor: pointer;\n}\n\n.baloa-play-my-clips__clip-container img {\n    border-radius: 8px;\n    height: 137px;\n    width: 100%;\n    object-fit: cover;\n}\n\n.baloa-play-my-clips__clip-container .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin-top: 12px;\n}\n\n.baloa-play-my-clips__match-data {\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n    margin-top: 12px;\n}\n\n\n.baloa-play-my-clips__match-data .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n\n    .baloa-play-my-clips__container {\n        padding: 10px;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .baloa-play-my-clips__clip-container .baloa-names {\n        margin-top: 0;\n    }\n\n    .baloa-play-my-clips__mobile-data {\n        display: flex;\n        gap: 12px;\n        margin-top: 12px;\n    }\n\n    .baloa-play-my-clips__mobile-data img {\n        height: 79px;\n        width: 129px;\n        border-radius: 6px;\n    }\n\n    .baloa-play-my-clips__match-data {\n        margin-top: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
